module.exports = __webpack_public_path__ + "img/Bhutan.3b684737.svg";